import * as types from '../actionType';

const initialState = {
  materialNamesList: [],
  materialConfigsState: {},
};

const materialReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_MATERIAL_NAMES_LIST:
      return {
        ...state,
        materialNamesList: action.payload,
      };
    case types.SET_MATERIAL_CONFIGS_STATE:
      return {
        ...state,
        materialConfigsState: {
          ...state.materialConfigsState,
          [action.payload.name]: action.payload.config
        },
      };
    default:
      return state;
  }
};

export default materialReducer;